
import HTML from "../assets/icons/html.png"
import CSS from "../assets/icons/css.png"
import JS from "../assets/icons/javascript.png"
import Linux from "../assets/icons/linux.png"
import Rect from "../assets/icons/react.png"
import Tailwind from "../assets/icons/tailwind.png"
import Node from "../assets/icons/node.png"
import Mongo from "../assets/icons/mongo.png"
import FireBase from "../assets/icons/firebase.png"
import Github from "../assets/icons/github.png"
import Git from "../assets/icons/git.png"
import Python from "../assets/icons/python.png"
import Type from "../assets/icons/typescript4.png"


export const dataIcons=[
    {
        id:1,
        name:"HTML",
        icons:HTML
    },
    {
        id:2,
        name:"CSS",
        icons:CSS
    },
    {
        id:3,
        name:"JS",
        icons:JS
    },
    {
        id:4,
        name:"TypeScript",
        icons:Type
    },
    {
        id:5,
        name:"Python",
        icons:Python
    },
    {
        id:6,
        name:"React",
        icons:Rect
    },
    {
        id:7,
        name:"Linux",
        icons:Linux
    },
    {
        id:8,
        name:"Nodejs",
        icons:Node
    },
    {
        id:9,
        name:"MongoDB",
        icons:Mongo

    },
    {
        id:10,
        name:"Tailwinds CSS",
        icons:Tailwind
    },
    {
        id:11,
        name:"FireBase",
        icons:FireBase
    },
    {
        id:12,
        name:"GitHub",
        icons:Github
    },
    {
        id:13,
        name:"Git",
        icons:Git
    },
    

]